import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axiosInstance from "../../utils/axiosInstance";

export const fetchBookmarks = createAsyncThunk(
  "bookmark/fetchBookmarks",
  async (squadId) => {
    const response = await axiosInstance(
      `/collections?squad_id=${squadId}`,
      "get",
    );
    return response.data.data;
  },
);

export const createBookmark = createAsyncThunk(
  "bookmark/createBookmark",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance("/collections", "post", data);
      return response.data.data;
    } catch (error) {
      throw rejectWithValue(error.response.data.message);
    }
  },
);

export const deleteBookmark = createAsyncThunk(
  "bookmark/deleteBookmark",
  async (data) => {
    const response = await axiosInstance(
      `/collections/${data.selectedBookmarkId}?squad_id=${data.squadId}`,
      "delete",
    );
    return response.data.data;
  },
);

export const updateBookmark = createAsyncThunk(
  "bookmark/updateBookmark",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance(
        `/collections/${data.selectedBookmarkId}?squad_id=${data.updateData.squadId}`,
        "put",
        data.updateData,
      );
      return response.data.data;
    } catch (error) {
      throw rejectWithValue(error.response.data.message);
    }
  },
);

const initialState = {
  bookmarks: [],
};

const bookmarkSlice = createSlice({
  name: "bookmark",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBookmarks.fulfilled, (state, action) => {
      state.bookmarks = action.payload;
    });
    builder.addCase(createBookmark.fulfilled, (state, action) => {
      state.bookmarks.push(action.payload);
    });
    builder.addCase(createBookmark.rejected, (state, action) => {
      throw action.payload;
    });
    builder.addCase(deleteBookmark.fulfilled, (state, action) => {
      state.bookmarks = state.bookmarks.filter((bookmark) => {
        return Number(bookmark.id) !== Number(action.payload);
      });
    });
    builder.addCase(updateBookmark.fulfilled, (state, action) => {
      state.bookmarks = state.bookmarks.map((bookmark) => {
        return bookmark.id === action.payload.id ? action.payload : bookmark;
      });
    });
    builder.addCase(updateBookmark.rejected, (state, action) => {
      throw action.payload;
    });
  },
});

export default bookmarkSlice.reducer;
